<template>
	<div class="msg-analysis-ta" v-if="!isError">
		<div class="msg-analysis-ta-info">
			<span class="msg-analysis-ta-img"></span>
			<span class="msg-analysis-ta-text">{{message.money}}<br/>{{message.pay_memo}}</span>
		</div>
		<div class="msg-analysis-ta-footer">
			<span>微信转账</span>
		</div>
	</div>
	<div class="msg-analysis-ta-error" v-else>
		转账消息格式错误，请在手机端查看！
	</div>
</template>

<script>
	import AppConfig from '../../../config/AppConfig.js'
	export default{
		name: 'MsgAnalysisTransfer_accounts',
		components:{
			
		},
		props:{
			msg:{
				  type:Object,
				  default:function(){
					  return {}
				  }
			}
		},
		data(){
			return {
				message: '',
				isError: false
			}
		},
		methods:{
			format(){
				try {
					let message = JSON.parse(this.msg.content);
					if(message.pay_memo === ''){
						message.pay_memo = '转账给你';
					}
					this.message = message
				}catch (e) {
					this.isError = true
				}
			}
		},
		
		created() {
			this.format()
		}
	}
</script>

<style>
	.msg-analysis-ta-error{
		background-color: #f19595;
		padding: 8px;
		font-size: 12px;
		border-radius: 2px;
	}
	.msg-analysis-ta{
	    background: #ffffff;
	    position: relative;
	    border: 1px solid #e8e8e8;
	    cursor: pointer;
	    border-radius: 4px;
	    min-width: 200px;
	}
	.msg-analysis-ta .msg-analysis-ta-info{
	    background-image: -moz-linear-gradient(to left,#f9a243,#fd6b34);
	    background-image: -o-linear-gradient(to left,#f9a243,#fd6b34);
	    background-image: -webkit-linear-gradient(to left,#f9a243,#fd6b34);
	    background-image: linear-gradient(to left,#f9a243,#fd6b34);
	    height: 60px;
	    line-height: 60px;
	    display: flex;
	    flex-direction:row;
	    flex-wrap: nowrap;
	    justify-content: left;
	    align-items:center;
	    align-content: flex-start;
	    padding: 0 5px;
	    border-radius: 4px 4px 0 0;
	}
	.msg-analysis-ta-info span{
	    display: block;
	    min-width: 30px;
	    max-width: 200px;
	    max-height: 60px;
	    overflow: hidden;
	    padding: 0 5px;
	    color: #ffffff;
	}
	.msg-analysis-ta-info .msg-analysis-ta-img{
	    width: 32px;
	    height: 32px;
	    padding: 0;
	    margin-right:5px;
	    margin-left:5px;
	    overflow: hidden;
	    background: url("/img/transfer_accounts.png") no-repeat;
	    background-size:32px 32px;
	}
	.msg-analysis-ta-info .msg-analysis-ta-text{
	    line-height: 18px;
	    height: 36px;
	    overflow: hidden;
	}
	.msg-analysis-ta .msg-analysis-ta-footer{
	    height: 20px;
	    line-height: 20px;
	    font-size: 12px;
	    color: #666666;
	    text-indent: 10px;
	}
</style>
